import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer as ChakraDrawer, DrawerContent, DrawerOverlay, } from '@chakra-ui/react';
import { InlineDrawer } from './inlineDrawer';
/**
 * Panel that slides out from the edge of the screen or parent conatiner (when inline).
 * It can be useful when you need users to complete a task
 * or view some details without leaving the current page.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/drawer
 * @see Inspiration https://v2.chakra-ui.com/community/recipes/horizontal-collapse
 */
export function Drawer({ children, isOpen, onClose, isInline = false, closeOnEsc = true, closeOnOverlayClick = true, autoFocus = true, placement = 'right', size = 'xs', ...props }) {
    if (isInline && size !== 'full') {
        return (_jsx(InlineDrawer, { isOpen: isOpen, onClose: onClose, size: size, closeOnEsc: closeOnEsc, ...props, children: children }));
    }
    return (_jsxs(ChakraDrawer, { isOpen: isOpen, autoFocus: autoFocus, onClose: onClose, placement: placement, closeOnEsc: closeOnEsc, closeOnOverlayClick: closeOnOverlayClick, size: size, ...props, children: [_jsx(DrawerOverlay, { bg: "rgba(0, 0, 0, 0.32)" }), _jsx(DrawerContent, { ...props, children: children })] }));
}
//# sourceMappingURL=drawer.js.map